<template>
  <div>
    <div class="newsTop">
      <h3>{{title}}</h3>
    </div>
    <div class="line"></div>
  </div>
</template>
<script>
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
    };
  },
  props: {
    title: {
      type:String
    }
  },
  mounted() {
    window.scroll(0, 0);
  },
  methods: {}
};
</script>
<style lang="less" scoped>
@color: #ff7234;
.newsTop {
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  h3 {
    font-size: 16px;
    color: #000;
    border-left: @color 2px solid;
    padding: 6px 10px;
    font-weight: 600;
  }
}
.line {
  width: 100%;
  margin: 0 auto;
  border-bottom: 1px solid #ccc;
}
</style>